// Number and date formatting for the Usage demo. Amounts are USD a year.

import { DEMO_TODAY } from "./fixtures";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "$2.9M", "$68K", "$684". */
export const money = (amount: number): string => {
    const abs = Math.abs(amount);
    const sign = amount < 0 ? "-" : "";
    if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `${sign}$${Math.round(abs / 1_000)}K`;
    return `${sign}$${Math.round(abs)}`;
};

/** "$2.4M to $3.4M", or the single amount. */
export const moneyRange = (range: { low: number; high?: number }): string =>
    range.high ? `${money(range.low)} to ${money(range.high)}` : money(range.low);

/** "12,400". */
export const int = (n: number): string => Math.round(n).toLocaleString("en-US");

const parse = (iso: string): Date => {
    const [y, m, d] = iso.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, d));
};

/** "21 Nov", with a non-breaking space so a cell never splits it. */
export const shortDate = (iso: string): string => {
    const d = parse(iso);
    return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`;
};

/** "21 Nov 2026". */
export const longDate = (iso: string): string => `${shortDate(iso)} ${parse(iso).getUTCFullYear()}`;

const DAY = 24 * 60 * 60 * 1000;

/** Whole days from the demo date to the date; negative once past. */
export const daysUntil = (iso: string): number =>
    Math.round((parse(iso).getTime() - parse(DEMO_TODAY).getTime()) / DAY);

/** "in 62 days", "tomorrow", "today", "3 days ago". */
export const relativeDays = (iso: string): string => {
    const days = daysUntil(iso);
    if (days === 0) return "today";
    if (days === 1) return "tomorrow";
    if (days === -1) return "yesterday";
    return days > 0 ? `in ${days} days` : `${-days} days ago`;
};
